import { getFilterMiddlewareParams } from '@intelligence/v3/filterControls/apiParams';
import { getFilterControlAdapter } from '@intelligence/v3/filterControls/controlAdapters';

import type { IFilterItemConfig } from '@intelligence/v3/filterCore/types';

/**
 * 汇总当前页面 Filter 控件管理的 URL 参数名。
 * 同步短链或明文 URL 时用它清理旧字段，避免遗留参数继续影响初始化。
 */
export const getManagedFilterUrlKeys = (items: IFilterItemConfig[]): string[] => {
  const managedUrlKeySet = new Set<string>();

  items?.forEach((item) => {
    const controlAdapter = getFilterControlAdapter(item?.type);

    if (!controlAdapter?.getManagedUrlKeys) {
      return;
    }

    const middlewareParams = getFilterMiddlewareParams(item);
    controlAdapter.getManagedUrlKeys(item, middlewareParams)?.forEach((key) => {
      if (key) {
        managedUrlKeySet.add(key);
      }
    });
  });

  return Array.from(managedUrlKeySet);
};
